/* Smooth-height accordion for the PDP Ingredients & Allergens rows.
   Moved out of a {% javascript %} tag in cake-block-info.liquid, which is a snippet —
   that tag only runs in section files, so this never executed. */
// Smooth height animation for the native <details> accordions. <details>/<summary> stays
// (accessible; with no JS it just toggles instantly). We intercept the summary click and
// animate the body's height between 0 and its content height. Double requestAnimationFrame
// commits the start height in its own frame before setting the target — a single reflow is
// skipped by the browser when the element just came out of display:none (the native closed
// state), which is why it snapped. Reduced-motion falls back to the native toggle.
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function nextFrame(fn) {
    requestAnimationFrame(function () { requestAnimationFrame(fn); });
  }

  // Instant page scroll. The theme sets `html { scroll-behavior: smooth }`, which would turn
  // every per-frame correction below into its own animation, lagging behind the accordion.
  // (Not scrollBy({behavior:'instant'}): that value throws on older Safari. Same trick as bh-drawer.js.)
  function scrollNow(dy) {
    if (Math.abs(dy) < 1) return;
    var root = document.documentElement;
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollBy(0, dy);
    root.style.scrollBehavior = prev;
  }

  function enhance(details) {
    if (details.__bhAcc) return;
    details.__bhAcc = true;
    var summary = details.querySelector('.bh-cake-info__summary');
    var body = details.querySelector('.bh-cake-info__text');
    if (!summary || !body) return;

    summary.addEventListener('click', function (e) {
      // Collapsing from the stuck header (you're somewhere inside the open section): close at
      // once and put the header back where it is on screen. Animating would shrink the content
      // above you and strand you further down the page.
      if (details.open) {
        var stuckAt = parseFloat(getComputedStyle(summary).top) || 0;
        if (details.getBoundingClientRect().top < stuckAt - 1) {
          e.preventDefault();
          var y = summary.getBoundingClientRect().top;
          details.open = false;
          window.scrollBy(0, details.getBoundingClientRect().top - y);
          return;
        }
      }
      if (reduce.matches) {         // native toggle, then hold the header in place once
        var at = summary.getBoundingClientRect().top;
        requestAnimationFrame(function () { scrollNow(summary.getBoundingClientRect().top - at); });
        return;
      }
      e.preventDefault();
      if (details.__anim) return;
      details.__anim = true;

      // Keep the tapped header where it is on screen for the whole animation, so the row opens
      // DOWNWARD. On desktop the image + accordions are one sticky column (cake-sticky-left in
      // bakehunters-configurator.css) taller than the screen, so its accordions are only in view
      // once it is pinned to the bottom of its grid area — and a bottom-pinned block can only
      // grow upward: opening shot the image and header up the page. Each frame, scroll the page
      // by however far the header moved. Where nothing moves (mobile, unpinned) the delta is 0.
      var anchorTop = summary.getBoundingClientRect().top;
      var pinning = true;
      (function pin() {
        if (!pinning) return;
        scrollNow(summary.getBoundingClientRect().top - anchorTop);
        requestAnimationFrame(pin);
      })();

      function onEnd(after) {
        body.addEventListener('transitionend', function te(ev) {
          if (ev.target !== body || ev.propertyName !== 'height') return;
          body.removeEventListener('transitionend', te);
          details.__anim = false;
          if (after) after();
          // One last correction after the final layout (open → height:auto, close → [open] off).
          requestAnimationFrame(function () {
            scrollNow(summary.getBoundingClientRect().top - anchorTop);
            pinning = false;
          });
        });
      }

      if (details.open) {
        // CLOSE: current height -> 0, then mark the row closed
        body.style.height = body.scrollHeight + 'px';
        nextFrame(function () { body.style.height = '0px'; });
        onEnd(function () { details.open = false; body.style.height = ''; });
      } else {
        // OPEN: reveal, then 0 -> full content height, then release back to auto
        details.open = true;
        body.style.height = '0px';
        nextFrame(function () { body.style.height = body.scrollHeight + 'px'; });
        onEnd(function () { body.style.height = ''; });
      }
    });
  }

  function init() {
    document.querySelectorAll('.bh-cake-info__row').forEach(enhance);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
